import { useMutation } from "@tanstack/react-query";
import { toggleBlogBookmark, toggleBlogLike, toggleBlogReadStatus } from "../services/blogService";

export function useBlogActions() {
  return {
    toggleLike: useMutation({ mutationFn: toggleBlogLike }),
    toggleBookmark: useMutation({ mutationFn: toggleBlogBookmark }),
    toggleReadStatus: useMutation({ mutationFn: toggleBlogReadStatus }),
  };
}
